var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C8.45 4 7.97917 3.80417 7.5875 3.4125C7.19583 3.02083 7 2.55 7 2C7 1.45 7.19583 0.979167 7.5875 0.5875C7.97917 0.195833 8.45 0 9 0C9.55 0 10.0208 0.195833 10.4125 0.5875C10.8042 0.979167 11 1.45 11 2C11 2.55 10.8042 3.02083 10.4125 3.4125C10.0208 3.80417 9.55 4 9 4ZM6 20V7C5 6.91667 3.98333 6.79167 2.95 6.625C1.91667 6.45833 0.933333 6.25 0 6L0.5 4C1.8 4.35 3.18333 4.60417 4.65 4.7625C6.11667 4.92083 7.56667 5 9 5C10.4333 5 11.8833 4.92083 13.35 4.7625C14.8167 4.60417 16.2 4.35 17.5 4L18 6C17.0667 6.25 16.0833 6.45833 15.05 6.625C14.0167 6.79167 13 6.91667 12 7V20H10V14H8V20H6Z",
    fill: "#5144B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.ad5820635d7194be73ed6a0bbb6a933f.svg";
export { ForwardRef as ReactComponent };